export default __webpack_public_path__ + "static/media/cert-startup-cpttm.4a98b79c.jpg";